module.exports = __webpack_public_path__ + "static/img/143533072.a9ffc94c.png";